import { useMemo, useState } from "react";
import { Box as MuiBox, Typography, Slider, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { Box } from "@/components/atoms";
import { YEAR_MIN, YEAR_MAX, useFilterCompanies } from "@/providers/contexts";
import { debounce } from "lodash";

export const YearFoundedRangeFilter = () => {
  const { filters, dispatch } = useFilterCompanies();

  const { selectedYearRangeMin, selectedYearRangeMax } = filters;

  const defaultRange = [YEAR_MIN, YEAR_MAX];
  const [localRange, setLocalRange] = useState<number[]>([
    selectedYearRangeMin ?? YEAR_MIN,
    selectedYearRangeMax ?? YEAR_MAX,
  ]);

  const debouncedDispatch = useMemo(
    () =>
      debounce((range: number[]) => {
        dispatch({
          type: "SET_FILTERS",
          payload: {
            selectedYearRangeMin: range[0],
            selectedYearRangeMax: range[1],
          },
        });
      }, 300),
    [dispatch],
  );

  const handleSliderChange = (_: any, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setLocalRange(newValue);
      debouncedDispatch(newValue);
    }
  };

  const clearSalaryFilter = () => {
    setLocalRange(defaultRange);
    dispatch({
      type: "SET_FILTERS",
      payload: {
        selectedYearRangeMin: YEAR_MIN,
        selectedYearRangeMax: YEAR_MAX,
      },
    });
  };

  const disableClear = localRange[0] === YEAR_MIN && localRange[1] === YEAR_MAX;

  const contents = (
    <>
      <MuiBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="subtitle1" sx={{ opacity: 1 }}>
          Year Founded
        </Typography>
        <IconButton
          onClick={clearSalaryFilter}
          size="small"
          disabled={disableClear}
          sx={{
            cursor: disableClear ? "not-allowed" : "pointer",
            opacity: disableClear ? 0.5 : 1,
          }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      </MuiBox>
      <Typography variant="subtitle2" sx={{ opacity: 1 }}>
        {localRange[0]} - {localRange[1]}
      </Typography>
      <Slider
        value={localRange}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        min={YEAR_MIN}
        max={YEAR_MAX}
        sx={{ marginBottom: 2 }}
      />
    </>
  );

  return (
    <Box
      componentName={`year-container`}
      sx={{
        mt: 2,
        padding: 2,
      }}
    >
      {contents}
    </Box>
  );
};
